import { render, staticRenderFns } from "./videoIndex.vue?vue&type=template&id=1bb34efa"
import script from "./videoIndex.vue?vue&type=script&lang=js"
export * from "./videoIndex.vue?vue&type=script&lang=js"
import style0 from "./videoIndex.vue?vue&type=style&index=0&id=1bb34efa&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports